/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentProviders/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Accounts from './Accounts/index'
import AddAction from './AddAction/index'
import ConfigurationTable from './ConfigurationTable/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import LocationSelect from './LocationSelect/index'
import React from 'react'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentProviders({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/PaymentProviders"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let constantData = 'Payment Providers for:'
let globalCurrentLocationParentCompanyNameValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.parent_company.name',
})
let aggregateData = fromAggregate.join(constantData, globalCurrentLocationParentCompanyNameValueData)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let authAccessTokenDataIsSupportValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let authAccessTokenDataIsSupportValueData1 = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="PaymentProviders.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-ZwXTSM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-ZwXTSM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-ZwXTSM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={dtSpaceM}
 level="h1"
 data="'Payment Providers for:'"
 data="global.current_location.parent_company.name"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 size="large"
 text="Setup Bluefin or Payabli payment accounts info here."
/>
<div
  data-testid="PaymentProviders.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-4-ZwXTSM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-5-ZwXTSM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PaymentProviders.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mr-6-ZwXTSM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<LocationSelect
  viewPath={`${viewPath}/LocationSelect`}
/>
</div>
</div>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
<div
  data-testid="PaymentProviders.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-4-ZwXTSM': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="PaymentProviders.Horizontal:2"
  data-view-path={viewPath}
 style={{'--w-7-ZwXTSM': authAccessTokenDataIsSupportValueData ? "80%" : "50%"}}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="PaymentProviders.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Provider"
/>
</div>
<div
  data-testid="PaymentProviders.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Account Id"
/>
</div>
<div
  data-testid="PaymentProviders.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Default"
/>
</div>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="PaymentProviders.Horizontal:6"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal6}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Status"
/>
</div>
<div
  data-testid="PaymentProviders.Horizontal:7"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal7}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Status changed By"
/>
</div>
<div
  data-testid="PaymentProviders.Horizontal:8"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal8}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Status Changed At"
/>
</div>
<div
  data-testid="PaymentProviders.Horizontal:9"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal9}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Actions"
/>
</div>
</React.Fragment>
)}
</SupportOnly>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={dtSpaceM}
 width={authAccessTokenDataIsSupportValueData1 ? "80%" : "50%"}
 backgroundColor={dtColorsNeutral200}
 data="auth.access_token_data.is_support"
/>
<Accounts
  viewPath={`${viewPath}/Accounts`}
/>
</div>
<ConfigurationTable
  viewPath={`${viewPath}/ConfigurationTable`}
/>
</div>
{children}
</React.Fragment>)
}